<template>
  <div class="mb-12">
    <div>
      <div class="aspect-ratio-3/2 mb-3">
        <div>
          <img class="programme-img rounded object-cover"
            :src="pg.thumbnail_image"
            :alt="pg.name" />
        </div>
      </div>
    </div>

    <div>
      <h4 class="fs-20 font-medium mt-4 mb-1">{{ pg.name }}</h4>
      <div class="programme-desc text-black-light-5" v-html="pg.short_description"></div>

      <button type="button"
        class="btn btn-outlined btn-secondary mt-4 w-full"
        @click="handleSetActiveProgramme">
        View details
      </button>

      <div class="flex items-center mt-6">
        <div class="flex-none w-1/2">
          <currency-context>
            <template v-slot="{ convert }">
              <span
                class="font-medium fs-20"
                v-text="convert(tripPrice)"
              ></span>
            </template>
          </currency-context>
          <span>{{ pricingBasis }}</span>
        </div>
        <div class="flex-none w-1/2 text-right">
          <div v-if="isProgrammeSelected === false">
            <button type="button"
              class="btn btn-secondary input-tall"
              @click="handleAddProgramme">
              <div class="flex items-center">
                <svg width="24" height="24" class="inline-block mr-2 fill-white">
                  <use xlink:href="/img/sprite.svg#ic_more"></use>
                </svg>
                Add
              </div>
            </button>
          </div>
          <div v-else class="inline-block">
            <numeral-stepper-new v-model="quantity" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NumeralStepperNew from '../core/NumeralStepperNew'
import CurrencyContext from '../core/CurrencyContext';
import EcoventureItemMixin from './mixins/EcoventureItemMixin'

export default {
  mixins: [EcoventureItemMixin],
  components: {
    NumeralStepperNew,
    CurrencyContext
  },
  props: ['pg']
}
</script>

<style scoped>
.programme-img {
  height: 100%;
  width: 100%;
}
</style>
